import { createFileRoute, Outlet } from '@tanstack/react-router';

import { modeStore } from '@apps/web/lib/mode_store';

export const Route = createFileRoute('/_app/(extension)')({
    beforeLoad: modeStore.activate,
    onLeave: modeStore.deactivate,
    component: ExtensionLayout,
});

function ExtensionLayout() {
    return <Outlet />;
}
